var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/CameraRoll") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5v15h20V5H2zm1.538 1.5h16.924v10.172l-5.986-5.836-.553-.516-.553.516-1.755 1.71-2.908-2.835-.553-.516-.553.516-4.063 3.96V6.5zM17 7.25c-1.052 0-1.923.85-1.923 1.875S15.948 11 17 11s1.923-.85 1.923-1.875S18.052 7.25 17 7.25zm0 1.5c.222 0 .385.158.385.375A.368.368 0 0 1 17 9.5a.368.368 0 0 1-.385-.375c0-.217.163-.375.385-.375zm-8.846 2.578l2.356 2.297-5 4.875H3.538v-2.672l4.616-4.5zm5.77 1.125l6.201 6.047H7.721l6.202-6.047z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.67c9c56e68b1416a9fa2364b145fed75.svg";
export { ForwardRef as ReactComponent };